var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("h5", [_vm._v("Создать запрос на получение баланса на картах")]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("p", [_vm._v("Доставочные карты")]),
            _vm._v(" "),
            _c("CustomMultiSelect", {
              ref: "selectedDeliveryCards",
              attrs: {
                records: _vm.getCardsByType("deliveryPrePaid"),
                options: { placeholder: "Выберите карты", useAllSelect: true },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("p", [_vm._v("Региональные карты")]),
            _vm._v(" "),
            _c("CustomMultiSelect", {
              ref: "selectedRegionCards",
              attrs: {
                records: _vm.getCardsByType("regionsPrePaid"),
                options: { placeholder: "Выберите карты", useAllSelect: true },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("p", [_vm._v("Почтовые карты")]),
            _vm._v(" "),
            _c("CustomMultiSelect", {
              ref: "selectedPostCards",
              attrs: {
                records: _vm.getCardsByType("postPrePaid"),
                options: { placeholder: "Выберите карты", useAllSelect: true },
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-footer text-right" },
        [
          _c("LoadingButton", {
            attrs: {
              title: "Создать задачу",
              loading: _vm.btnLoading,
              color: _vm.$constants.PRIMARY_COLOR,
              onClick: () => _vm.createTask(),
              className: "btn btn-outline-info",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [_c("BalanceHistoryTasks", { ref: "balanceHistory" })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }